import otp from './OTP'

export default {
  otp,
}
